export interface EditCategoryRedux {
  category_id: number;
  category_name: string;
  category_for: string;
  isAvailable: string;
}
const initialState: EditCategoryRedux = {
  category_id: 0,
  category_name: "",
  category_for: "",
  isAvailable: "",
};

export type CategoryAction =
  | {
      type: "EDITCATEGORY";
      payload: EditCategoryRedux;
    }
  | {
      type: "CLEARCATEGORY";
    };

export const categoryReducer = (
  state: EditCategoryRedux = initialState,
  action: CategoryAction
) => {
  switch (action.type) {
    case "EDITCATEGORY":
      return action.payload;
    case "CLEARCATEGORY":
      return initialState;
    default:
      return state;
  }
};
